<template>
  <div class="page-container">
    <el-card class="mb-20">
      <app-filter
        :filter-list="table_filter"
        default-label-width="100px"
        @search="onSearch"
      />
    </el-card>
    <el-card>
      <div class="text-right mb-20">
        <el-button size="mini" type="primary" @click="onAdd">新增标签</el-button>
      </div>
      <app-table
        ref="table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getMaterialLabelList"
      />
    </el-card>
    <!-- 新增/绑定/解绑弹窗 -->
    <el-dialog
      :visible.sync="dialog_config.is_show"
      :title="dialog_config.title"
      :width="dialog_config.width"
    >
      <app-form
        v-if="dialog_config.is_show"
        v-loading="dialog_config.is_loading"
        :form-data="dialog_config.form_config"
        default-label-width="100px"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      >
        <template #custom="{form_item, form_key}">
          <div v-if="form_key === 'material'">
            <material-form
              v-if="form_key === 'material'"
              channel-interface="gdt"
              :material-data="form_item.value"
              :is-show-add-btn="form_item.type === 'bind'"
            />
          </div>
        </template>
      </app-form>
    </el-dialog>
  </div>
</template>

<script>
import { getMediasListApi } from '@/api/medias';
import {
  getMaterialLabelListApi,
  getMaterialLabelSelectorApi,
  addMaterialLabelApi,
  delMaterialLabelApi,
  bindMaterialLabelApi,
  unbindMaterialLabelApi,
  getMaterialByLabelApi,
} from '@/api/tool/material-label';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'app-form': () => import('@/components/app-form'),
    'material-form': () => import('@/components/business/material/material-form'),
  },
  data() {
    return {
      // 过滤项
      table_filter: require('./model/table-filter')(this),
      // 表头数据
      table_key: require('./model/table-key')(this),
      // 表格请求参数
      table_params: {
        channel_interface: CHANNEL_INTERFACE_TYPE.GDT,
        page: 1,
        page_size: 10,
      },
      /** 弹窗配置 */
      dialog_config: {
        is_show: false,
        is_loading: false,
        title: '',
        width: '500px',
        form_config: {},
      },
      advertiser_id_options: [],
    };
  },
  async created() {
    const { filtering: { children: { advertiser_ids }}} = this.table_filter;
    this.advertiser_id_options = await this.getAdvertiserList(CHANNEL_INTERFACE_TYPE.GDT);
    advertiser_ids.options = this.advertiser_id_options;
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 搜索条件
     */
    onSearch(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },
    /** 新增 */
    onAdd() {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '新增',
        width: '500px',
        form_config: require('./model/form-config.js')(this),
        confirm: (params) => {
          this.dialog_config.is_loading = true;
          const { channel_interface, advertiser_id, name, business_scenario } = params;
          const payload = {
            channel_interface,
            advertiser_id,
            name,
            gdt_params: { business_scenario },
          };
          this.dialog_config.is_loading = true;
          addMaterialLabelApi(payload).then(({ message }) => {
            this.$message.success(message || '绑定成功');
            this.dialog_config.is_show = false;
            this.$refs.table.seekTable();
          }).finally(() => {
            this.dialog_config.is_loading = false;
          });
        },
      });

      const { channel_interface, advertiser_id, name } = this.dialog_config.form_config;
      channel_interface.hidden = false;
      advertiser_id.hidden = false;
      advertiser_id.options = this.advertiser_id_options;
      name.hidden = false;
    },
    /** 绑定 */
    onBind(row) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '绑定',
        width: '800px',
        form_config: require('./model/form-config.js')(this),
        confirm: (params) => {
          const { id: label_id, advertiser: channel_interface, advertiser_id } = row;
          const { business_scenario, material } = params;
          const images_list = (material.images || []).map(({ id, material_type, name, url }) => ({ id, material_type, name, url: url[0].url }));
          const videos_list = (material.videos || []).map(({ id, material_type, name, url }) => ({ id, material_type, name, url: url[0].url }));
          const payload = {
            channel_interface,
            advertiser_id,
            label_id,
            gdt_params: { business_scenario },
            materials: [...images_list, ...videos_list],
          };
          this.dialog_config.is_loading = true;
          bindMaterialLabelApi(payload).then(({ message }) => {
            this.$message.success(message || '绑定成功');
            this.dialog_config.is_show = false;
            this.$refs.table.seekTable();
          }).finally(() => {
            this.dialog_config.is_loading = false;
          });
        },
      });

      const { material } = this.dialog_config.form_config;
      material.hidden = false;
      material.type = 'bind';
      material.label = '素材';
    },
    /** 解绑 */
    onUnbind(row) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '解绑',
        width: '800px',
        form_config: require('./model/form-config.js')(this),
        confirm: (params) => {
          const { id: label_id, advertiser: channel_interface, advertiser_id } = row;
          const { business_scenario, material } = params;
          const images_list = (material.images || []).map(({ id, material_type, name, url }) => ({ id, material_type, name, url: url[0].url }));
          const videos_list = (material.videos || []).map(({ id, material_type, name, url }) => ({ id, material_type, name, url: url[0].url }));
          const payload = {
            channel_interface,
            advertiser_id,
            label_id,
            gdt_params: { business_scenario },
            materials: [...images_list, ...videos_list],
          };
          this.dialog_config.is_loading = true;
          unbindMaterialLabelApi(payload).then(({ message }) => {
            this.$message.success(message || '解绑成功');
            this.dialog_config.is_show = false;
            this.$refs.table.seekTable();
          }).finally(() => {
            this.dialog_config.is_loading = false;
          });
        },
      });

      const { material } = this.dialog_config.form_config;
      material.hidden = false;
      material.type = 'unbind';
      material.label = '待解绑素材';

      this.dialog_config.is_loading = true;
      const { id, advertiser: channel_interface, advertiser_id } = row;
      const payload = {
        channel_interface,
        advertiser_id,
      };
      getMaterialByLabelApi(id, payload).then(({ images, videos }) => {
        const images_list = (images || []).map(({ urls, ...rest }) => ({ url: [{ url: urls, thumb_url: urls }], material_type: 1, ...rest }));
        const videos_list = (videos || []).map(({ url, cover, ...rest }) => ({ url: [{ url, thumb_url: cover }], material_type: 2, ...rest }));
        material.value.images.push(...images_list);
        material.value.videos.push(...videos_list);
      }).finally(() => {
        this.dialog_config.is_loading = false;
      });
    },
    /** 删除 */
    onDel(row) {
      const { id, name } = row;
      const h = this.$createElement;
      const message_ele = h('div', { class: 'flex-col align-center' }, [
        h('div', { class: 'mb-10 color-red' }, name),
        h('div', { class: 'mb-10' }, '是否删除当前媒体素材标签'),
      ]);
      this.$msgbox({
        title: '提示',
        message: message_ele,
        showCancelButton: true,
      }).then(() => {
        const { advertiser: channel_interface, advertiser_id } = row;
        const params = {
          channel_interface,
          advertiser_id,
        };
        delMaterialLabelApi(id, params).then(({ message }) => {
          this.$message.success(message || '操作成功');
          this.$refs.table.seekTable();
        });
      });
    },
    /**
     * 获取渠道素材标签列表
     * @param {Object} params 过滤参数
     * @returns {Promise<Object>}
     */
    getMaterialLabelList(params) {
      return new Promise((resolve, reject) => {
        getMaterialLabelListApi(params).then(resolve).catch(reject);
      });
    },
    /**
     * 获取渠道素材标签列表
     * @param {Object} params 过滤参数
     * @returns {Promise<Object>}
     */
    getMaterialLabelSelector(params) {
      return new Promise((resolve, reject) => {
        getMaterialLabelSelectorApi(params).then(resolve).catch(reject);
      });
    },
    /**
     * 获取广告主账号列表
     * @param {string} type 渠道接口
     * @returns {Promise<Object[]>}
     */
    getAdvertiserList(type) {
      return new Promise((resolve, reject) => {
        getMediasListApi({
          type,
          is_list: true,
        }).then(res => {
          const result = res.list.map(({ advertiser_id, advertiser_name, note }) => {
            return {
              label: `${advertiser_id}（${advertiser_name}）${note ? ' - ' + note : ''}`,
              value: advertiser_id,
            };
          });
          resolve(result);
        }).catch(reject);
      });
    },
  },
};
</script>
